export default "__VITE_ASSET__BwrGd294__"